import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { fieldClass } from './TextField';
type SelectFieldProps = React.SelectHTMLAttributes<HTMLSelectElement> & {
  label: string;
  name: string;
  options: string[];
  placeholder?: string;
  error?: string;
};
export function SelectField({
  label,
  name,
  options,
  placeholder = 'Select…',
  error,
  required,
  className = '',
  ...rest
}: SelectFieldProps) {
  const id = `field-${name}`;
  return <div className={className} data-id="element-63" data-mp="vi4bwu9wpjxu">
      <label htmlFor={id} className="font-slab text-sm font-bold uppercase tracking-[0.18em] text-cream" data-id="element-64" data-mp="rhlkv2fu8hwp">
        {label}
        {required && <span className="text-neon-2" data-id="element-65" data-mp="mh6564832ybk"> *</span>}
      </label>
      <div className="relative" data-id="element-66" data-mp="hjehjmeh1yd6">
        <select id={id} name={name} required={required} aria-invalid={!!error} className={`${fieldClass} appearance-none pr-10 ${error ? 'border-red-400' : ''}`} defaultValue="" {...rest} data-id="element-67" data-mp="hi34evz4ze9e">
          <option value="" disabled data-id="element-68" data-mp="3et9fmlqvx0ol">
            {placeholder}
          </option>
          {options.map(o => <option key={o} value={o} data-id="element-69" data-mp="3iuuxklia055n">
              {o}
            </option>)}
        </select>
        <ChevronDownIcon className="pointer-events-none absolute right-3 top-1/2 mt-1 h-4 w-4 -translate-y-1/2 text-ink-muted" aria-hidden="true" data-id="element-70" data-mp="34tqva472bcw0" />
      </div>
      {error && <p className="mt-1.5 text-xs text-red-300" data-id="element-71" data-mp="2v58zy2hjxxzr">{error}</p>}
    </div>;
}